import { render, staticRenderFns } from "./SearchdemurrageDetailForm.vue?vue&type=template&id=0fa0287a&scoped=true"
import script from "./SearchdemurrageDetailForm.vue?vue&type=script&lang=js"
export * from "./SearchdemurrageDetailForm.vue?vue&type=script&lang=js"
import style0 from "./SearchdemurrageDetailForm.vue?vue&type=style&index=0&id=0fa0287a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0287a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa0287a')) {
      api.createRecord('0fa0287a', component.options)
    } else {
      api.reload('0fa0287a', component.options)
    }
    module.hot.accept("./SearchdemurrageDetailForm.vue?vue&type=template&id=0fa0287a&scoped=true", function () {
      api.rerender('0fa0287a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/SearchdemurrageDetailForm.vue"
export default component.exports